import {Controller} from "stimulus"

/*
 * Keeps the "Shifts to be created" preview on the New Opportunity from
 * template form anchored on the start date being entered. The preview is a
 * Turbo Frame that the form's own page renders, so its dates are worked out by
 * the same code that creates the shifts; this only points the frame at the
 * chosen date.
 */
export default class extends Controller {
  static targets = ["frame"]

  update(event) {
    const url = new URL(this.data.get("url"), window.location.origin)
    // Sent even when cleared: a page asked for no start date at all previews
    // today's shifts, where a blank one asks for a date.
    url.searchParams.set("start_date", event.target.value)
    this.frameTarget.setAttribute("src", url.toString())
  }
}
